import { mergeAttributes, Node } from "@tiptap/core";

import { setNodeViewAttrs } from "@/editor/adapters/utils";

import { Props as CheckboxProps } from "./";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    nwCheckbox: {
      setNWCheckbox: () => ReturnType;
    };
  }
}

export const NWCheckboxAdapter = Node.create<CheckboxProps>({
  name: "nw-checkbox",
  group: "block",
  content: "inline*",
  marks: "_",

  addOptions() {
    return {
      checked: false,
      size: "md",
    };
  },

  parseHTML() {
    return [
      {
        tag: "nw-checkbox",
        getAttrs: node => {
          return {
            checked: node.getAttribute("checked") === "true",
            disabled: node.getAttribute("disabled") === "true",
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["nw-checkbox", mergeAttributes(HTMLAttributes), 0];
  },

  addNodeView() {
    return ({ node, getPos, editor }) => {
      const dom = document.createElement("nw-checkbox");
      setNodeViewAttrs(dom, node.attrs);

      const onCheckboxChange = ((event: CustomEvent) => {
        editor
          .chain()
          .command(({ tr }) => {
            tr.setNodeAttribute(getPos(), "checked", event.detail.checked);
            return true;
          })
          .setTextSelection({ from: editor.state.selection.from, to: editor.state.selection.from })
          .run();
      }) as EventListener;

      dom.addEventListener("checkbox-change", onCheckboxChange);

      return {
        dom,
        contentDOM: dom,
      };
    };
  },

  addAttributes() {
    return {
      checked: {
        default: false,
        parseHTML: element => element.getAttribute("checked") === "true",
        renderHTML: attributes => ({
          checked: attributes.checked,
        }),
      },
      disabled: {
        default: false,
        parseHTML: element => element.getAttribute("disabled") === "true",
        renderHTML: attributes => ({
          disabled: attributes.disabled,
        }),
      },
    };
  },

  addCommands() {
    return {
      setNWCheckbox:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
          });
        },
    };
  },
});
